import { useCheckoutContext } from '../index'
import type { PaymentOptions } from '../types'
import { formatMoney } from '@ztechapps/common.utils'

export const usePaymentValidation = () => {
  const checkoutContext = useCheckoutContext()
  const balance = checkoutContext?.orderDocumentResult?.document?.paymentBalance?.balance ?? 0

  return (args?: PaymentOptions): Record<any, any> => {
    const newErrors: Record<string, any> = {}

    const amount = args?.amount

    if (!amount) {
      newErrors.amount = 'Required'
    } else {
      if (amount === 0) {
        newErrors.amount = '**Invalid amount'
      }

      if (amount > balance && balance > 0) {
        newErrors.amount = `Maximum valid amount is ${formatMoney(balance)}`
      }
    }

    if (balance === 0) {
      newErrors.amount = `You don't have payment balance`
    }

    return newErrors
  }
}
